import { render } from "./ShowFacture.vue?vue&type=template&id=a8a9f55e"
import script from "./ShowFacture.vue?vue&type=script&lang=js"
export * from "./ShowFacture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__